// Column checklist per broker — used for the downloadable CSV templates so the
// user knows exactly what to tick when exporting from each broker portal.
export const BROKER_TEMPLATES = {
  HFM: {
    note: 'Portal HFM → Reports → Clients/Accounts. Tick semua column di bawah.',
    columns: ['Name', 'Wallet ID', 'Trading Account ID', 'Status', 'Type', 'Acc. Currency', 'Country',
      'Trading Account Registration', 'Trades', 'Volume', 'Commission', 'First Trade', 'Last Trade',
      'Balance', 'Equity', 'Free Margin', 'Bonus'],
    sample: ['Nabil Fikri', '58692229', '198461854', 'Approved', 'PREMIUM', 'USD', 'Malaysia',
      '2026-02-11', '130', '3.98', '9.02', '2026-02-12', '2026-08-13', '2131.87', '2350.65', '2200.00', '0'],
    basis: 'Kumulatif / All-time',
  },
  VANTAGE: {
    note: 'Portal Vantage → Reports → Rebate (sheet "account rebate" ada tarikh per baris).',
    columns: ['Name', 'User ID', 'Account', 'Date', 'Total Volume', 'Rebate(USD)', 'Balance', 'Equity'],
    sample: ['Gerald Guallar', '4013927', '30084849', '2026-08-13', '14.90', '74.50', '0', '0'],
    basis: 'Harian',
  },
  OCTA: {
    note: 'Portal Octa/Elev8 → Reports. Perlu report PER CLIENT (bukan aggregate) — minta account/login column.',
    columns: ['Client Name', 'Account', 'Date', 'Lots', 'Commission', 'Balance', 'Equity', 'Last Trade'],
    sample: ['Ahmad Ali', '1234567', '2026-08-18', '2.50', '12.30', '850.00', '910.40', '2026-08-18'],
    basis: 'Harian atau Kumulatif',
  },
  XM: {
    note: 'Portal XM → Reports → Trading Accounts / Clients (bukan report aggregate).',
    columns: ['Client Name', 'Account', 'Registration Date', 'Trades', 'Lots', 'Commission', 'Balance', 'Equity', 'Last Trade'],
    sample: ['Siti Nur', '5551234', '2026-05-02', '48', '6.20', '28.90', '1200.00', '1310.55', '2026-08-17'],
    basis: 'Kumulatif / All-time',
  },
  PEPPERSTONE: {
    note: 'Portal Pepperstone → Partner Reports → Client Report.',
    columns: ['Client Name', 'Account', 'Date', 'Lots', 'Commission', 'Balance', 'Equity', 'Last Trade'],
    sample: ['Lim Wei', '778812', '2026-08-18', '1.80', '9.40', '640.00', '655.20', '2026-08-18'],
    basis: 'Harian atau Kumulatif',
  },
  UNIVERSAL: {
    note: 'Template universal — guna kalau broker lain. Sistem boleh baca semua column ni.',
    columns: ['Client Name', 'Account', 'Wallet ID', 'Account Type', 'Currency', 'Country',
      'Registration Date', 'Date', 'Trades', 'Lots', 'Commission', 'First Trade', 'Last Trade',
      'Balance', 'Equity', 'Free Margin', 'Bonus', 'Deposit', 'Withdrawal', 'Status'],
    sample: ['Ahmad Ali', '1234567', '99001', 'STANDARD', 'USD', 'Malaysia', '2026-03-01', '2026-08-18',
      '25', '3.10', '15.50', '2026-03-05', '2026-08-18', '1000.00', '1085.00', '980.00', '0', '1000.00', '0', 'Active'],
    basis: 'Ikut pilihan masa upload',
  },
};

export const downloadBrokerTemplate = (broker) => {
  const t = BROKER_TEMPLATES[broker] || BROKER_TEMPLATES.UNIVERSAL;
  const csv = [t.columns.join(','), t.sample.map((v) => `"${v}"`).join(',')].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `template_${broker.toLowerCase()}.csv`;
  a.click();
};
